import { useMemo } from 'react';
import { sumOf } from '../../../shared/utils/arrayUtils.ts';
import { getAddedConfirmedScraps, getConfirmedScraps } from '../../../shared/utils/scrapUtils.ts';
import { Operation } from '../../types/sharedTypeImpl.ts';

export interface ScrapTotals {
    numCases: number;
    potentialScraps: number;
    initialScraps: number;
    confirmedScraps: number;
    releasedScraps: number;
}


export function useScrapTotal(operations: Operation[] | null): ScrapTotals | null {
    const scrapTotals = useMemo(() => {
        if (!operations) return null;

        const numCases = operations.length;
        const potentialScraps = sumOf(operations, it => it.potentialScraps ?? 0);
        const initialScraps = sumOf(operations, it => it.confirmedScraps ?? 0);
        const addedConfirmedScraps = sumOf(operations, getAddedConfirmedScraps);
        const finalConfirmedScraps = sumOf(operations, getConfirmedScraps);
        const releasedScraps = potentialScraps - addedConfirmedScraps;
        return { numCases, potentialScraps, initialScraps, confirmedScraps: finalConfirmedScraps, releasedScraps };
    }, [operations]);

    return scrapTotals;
}
